import React, { Component } from 'react';

class NotFoundPage extends Component {
  render() {
    return <div>Resource not found.</div>;
  }
}

export default NotFoundPage;
